<template>
  <g id="baker">
    <path
      class="cls-32"
      d="M1470.5 1020h-296.7v-.3a142.3 142.3 0 012.7-27.1 134.3 134.3 0 018.6-27.4 138.4 138.4 0 0143.3-54.8 145 145 0 0120.9-12.9 136.5 136.5 0 0161.2-14.4h23.1a135.8 135.8 0 0161.4 14.5 146.9 146.9 0 0120.8 12.8 139 139 0 0127.3 27.4 136.4 136.4 0 0116 27.4 141.1 141.1 0 018.7 27.4 137.6 137.6 0 012.7 27.4z"
      transform="translate(17)"
    />
    <path class="cls-4" d="M1487.5 1020h-296.7v-.3l2.7-27.1h291.3l2.7 27.4z" />
    <path
      class="cls-4"
      d="M1459.1 965.2h-274a141.3 141.3 0 0116-27.4h242a136.4 136.4 0 0116 27.4zM1415.8 910.4h-187.4a136.1 136.1 0 0182.1-27.3h23.1a137.1 137.1 0 0182.2 27.3z"
      transform="translate(17)"
    />
    <g>
      <path
        class="cls-13"
        d="M1209.4 828.6h69.9V676.3h-69.9a76.1 76.1 0 00-74.9 62.7 76.2 76.2 0 0074.9 89.6zM1434.9 828.6h-69.8V676.3h69.8a76.2 76.2 0 0175 62.7c8.4 46.6-27.5 89.6-75 89.6z"
        transform="translate(17)"
      />
    </g>
    <path
      class="cls-13"
      d="M1339.2 551a142 142 0 01142 142A114.1 114.1 0 011367 807.1h-55.7A114.1 114.1 0 011197.2 693a142 142 0 01142-142z"
    />
    <path
      class="cls-33"
      d="M1208.2 700.8h82v59.3h-82a29.7 29.7 0 01-29.7-29.7 29.6 29.6 0 0129.7-29.6zM1436.7 700.8h-82.6v59.3h82.6a29.7 29.7 0 0029.7-29.7 29.6 29.6 0 00-29.7-29.6z"
      transform="translate(17)"
    />
    <path
      class="cls-16"
      d="M1395 897.6a73.1 73.1 0 01-72.7 67.6h-.1a73.2 73.2 0 01-72.9-67.7 136.5 136.5 0 0161.2-14.4h23.1a135.8 135.8 0 0161.4 14.5z"
      transform="translate(17)"
    />
    <path
      class="cls-33"
      d="M1293.5 847.1h91.3v45.2a45.5 45.5 0 01-45.5 45.5h-.1a45.7 45.7 0 01-45.7-45.7v-45z"
    />
    <rect class="cls-16" x="1225.1" y="588.9" width="228.2" height="285.29" rx="114.1" />
    <circle class="cls-18" cx="1281" cy="714" r="13.7" />
    <circle class="cls-18" cx="1397.4" cy="714" r="13.7" />
    <path
      class="cls-34"
      d="M1339.1 696.9a22.9 22.9 0 0122.9 22.9v22.1h-45.6v-22.3a22.7 22.7 0 0122.7-22.7z"
    />
    <path
      class="cls-19"
      d="M1390.6 760.1a70.8 70.8 0 01-3.7 22.8 67.5 67.5 0 01-32.9 38 69.4 69.4 0 01-64.1-.3 67.1 67.1 0 01-32.4-37.7 68.2 68.2 0 01-3.8-22.8z"
      transform="translate(17)"
    />
    <path
      class="cls-20"
      d="M1390.6 760.1a70.8 70.8 0 01-3.7 22.8h-129.4a68.2 68.2 0 01-3.8-22.8z"
      transform="translate(17)"
    />
    <path
      class="cls-21"
      d="M1354 820.9a69.4 69.4 0 01-64.1-.3 34.4 34.4 0 0164.1.3z"
      transform="translate(17)"
    />
    <g>
      <path
        class="cls-13"
        d="M1371.3 581.6h-73.1a90.2 90.2 0 00-90.1 90.2v29a125.2 125.2 0 0093.1-41.5z"
        transform="translate(17)"
      />
      <path
        class="cls-13"
        d="M1273 581.6h72.9a90.3 90.3 0 0190.3 90.3v28.9a125.3 125.3 0 01-93.1-41.5z"
        transform="translate(17)"
      />
    </g>
  </g>
</template>